export const autoplayPlugin = (slider, time) => {
  let timeout;
  let mouseOver = false;
  let destroyed = false;
  function clearNextTimeout() {
    clearTimeout(timeout);
  }
  function nextTimeout() {
    clearTimeout(timeout);
    if (mouseOver || destroyed) {
      return;
    }
    timeout = setTimeout(() => {
      slider.next();
    }, time);
  }
  slider.on('created', () => {
    slider.container.addEventListener('mouseover', () => {
      mouseOver = true;
      clearNextTimeout();
    });
    slider.container.addEventListener('mouseout', () => {
      mouseOver = false;
      nextTimeout();
    });
    nextTimeout();
  });
  slider.on('dragStarted', clearNextTimeout);
  slider.on('animationEnded', nextTimeout);
  slider.on('updated', nextTimeout);
  slider.on('destroyed', () => {
    destroyed = true;
    clearNextTimeout();
  });
};
